import { render, staticRenderFns } from "./page-memberList.vue?vue&type=template&id=672f8a79&scoped=true&"
import script from "./page-memberList.vue?vue&type=script&lang=js&"
export * from "./page-memberList.vue?vue&type=script&lang=js&"
import style0 from "./page-memberList.vue?vue&type=style&index=0&id=672f8a79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f8a79",
  null
  
)

export default component.exports